import React, { Component } from 'react';
import { Input, Space, Button, Typography, Slider, Row, Col, Switch } from 'antd';
import { LeftOutlined, RightOutlined, MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { googleUrl } from '../config.js'

const { Title } = Typography;

export default class Header extends Component {
	state = {
		url: '',
	}

	saveUrl = (e) => {
		if (e.keyCode === 13) {
			this.handleSubmit(e)
		}
	}

	writeUrl = (e) => {
		this.setState({ url: e.target.value })
	}

	handleSubmit = (e) => {
		e.preventDefault()
		const { url } = this.state
		if (url.trim() === '') {
			return
		}
		if (this.judgeUrl(url)) {
			if (url.includes('http://') || url.includes('https://')) {
				this.props.pushAndVisitUrl(url)
			} else {
				this.props.pushAndVisitUrl('https://' + url)
			}
		} else {
			this.props.pushAndVisitUrl(googleUrl + url)
		}
	}

	judgeUrl = (str) => {
		// var Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;	// 含http
		var Expression = /([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
		var objExp = new RegExp(Expression);
		if (objExp.test(str)) {
			return true;
		} else {
			return false;
		}
	}

	componentDidUpdate(prevProps, _){
		if (prevProps.showUrl !== this.props.showUrl){
			this.setState({ url: this.props.showUrl})
		}
	}

	render() {
		return (
			<div className={'header'}>
				<Row align='middle' justify='center'>
					<Col span={21}>
						<Title level={2}>GraphAnalysis</Title>
					</Col>
					<Col span={3}>
						<Switch checkedChildren="整编" unCheckedChildren="浏览" checked={this.props.mode} onChange={this.props.changeMode} />
					</Col>
				</Row>
				<Space align='center'>
					<Button type={'ghost'} icon={<LeftOutlined />} onClick={this.props.handleBackward} />
					<Button type={'ghost'} icon={<RightOutlined />} onClick={this.props.handleForward} />
					<Input value={this.state.url} onKeyUp={this.saveUrl} onChange={this.writeUrl} type="text" name="urlinput" style={{ width: "23vw" }} size="middle" placeholder={'请输入网址……'} />
					<Button type="primary" onClick={this.handleSubmit} onSubmit={this.handleSubmit}>Go</Button>
					<Button type={'ghost'} icon={<MinusOutlined/>} onClick={this.props.downScale}/>
					<Slider value={this.props.scale} defaultValue={100} style={{width:'3vw'}} min={50} max={150} step={10} onChange={this.props.setScale} />
					<Button type={'ghost'} icon={<PlusOutlined />} onClick={this.props.upScale}/>
				</Space>
			</div>
		)
	}
}
